export default __webpack_public_path__ + "static/media/lignes.d6d7ba03.svg";